<template>
  <div class="box">
    <!-- 对账统计 -->
    <reconciliation-stat />
    <!-- Tab 标签页 -->
    <reconciliation-tabs />
  </div>
</template>
<script>
import ReconciliationStat from "./components/ReconciliationStat.vue";
import ReconciliationTabs from "./components/ReconciliationTabs.vue";
export default {
  name: "wlReconciliation",
  components: {
    ReconciliationStat,
    ReconciliationTabs
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
.box {
  height: 100%;
  overflow-y: scroll;
}
</style>
